import * as React from 'react';
import { useDeleteWithConfirmController, type DeleteWithConfirmButtonProps } from 'react-admin';
import { Button, Dialog, DialogContent, DialogActions } from '@mui/material';
import { shsButtonStyles } from 'src/styles';
import { ReactComponent as DeleteIcon } from 'src/assets/trash-can.svg';
import { ShsButton } from 'src/components/common';
import { useRecordContext, useResourceContext, useRedirect, useNotify } from 'react-admin';

type Props = DeleteWithConfirmButtonProps & {
    confirmContent: React.ReactNode;
    label?: string;
};

const ShsDeleteWithConfirm: React.FC<Props> = ({ confirmContent, label = 'Видалити', ...rest }) => {
    const record = useRecordContext();
    const resource = useResourceContext();
    const redirect = useRedirect();
    const notify = useNotify();

    if (!record?.id) return null;

    const ctrl = useDeleteWithConfirmController({
        ...rest,
        record,
        resource,
        mutationOptions: {
            onSuccess: () => {
                notify('Елемент видалений', { type: 'info' });
                redirect('list', resource);
            }
        }
    });

    return (
        <>
            <Button
                onClick={ctrl.handleDialogOpen}
                className="shs-button outline-danger"
                sx={shsButtonStyles}
                startIcon={<DeleteIcon style={{ fill: '#F23030' }} />}>
                {label}
            </Button>

            <Dialog open={ctrl.open} onClose={ctrl.handleDialogClose} maxWidth="sm" fullWidth>
                <DialogContent sx={{ p: 3 }}>{confirmContent}</DialogContent>

                <DialogActions sx={{ justifyContent: 'center', gap: 2, p: 3 }}>
                    <ShsButton label="Скасувати" styleType="outline" onClick={ctrl.handleDialogClose} />
                    <ShsButton label="Видалити" styleType="filled-danger" onClick={ctrl.handleDelete} />
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ShsDeleteWithConfirm;
